import { createFileRoute, redirect } from '@tanstack/react-router'
import { getV1MeRetrieveQueryOptions } from '@/api/client'
import { CurriculumEnrollmentsScreen } from '@/components/curriculum/curriculum-enrollments-screen'

/**
 * Zapisy klas do planu nauczania.
 *
 * Ta sama bramka roli co `/plan-nauczania`: odczyt planu — a zapisy siedzą na
 * `CurriculumAdminReadView` — jest dla admina i superadmina, nauczyciel i uczeń
 * nie mają tu nic do roboty. Cały widok jest w `CurriculumEnrollmentsScreen`,
 * żeby dał się renderować w teście bez routera.
 */
export const Route = createFileRoute('/_panel/plan-nauczania/zapisy')({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(getV1MeRetrieveQueryOptions())
    if (me.status === 200 && me.data.role !== 'admin' && me.data.role !== 'superadmin') {
      throw redirect({ to: '/' })
    }
  },
  component: CurriculumEnrollmentsScreen,
})
